import { IconProductL } from 'icons/components/IconProductL'
import { cx } from 'utils/cx'

import styles from './ImageNotFound.module.scss'

interface ImageNotFoundProps {
	dataTestId?: string
	height?: number
	width?: number
	className?: string
}

export const ImageNotFound = (props: ImageNotFoundProps) => {
	const { dataTestId, height, width, className } = props

	return (
		<div
			data-testid={dataTestId}
			className={cx(className, styles.error)}
			style={{ width, height }}
			aria-hidden
		>
			<IconProductL />
		</div>
	)
}
